export type AnalyticEventCategory =
  | 'unknown'
  | 'click'
  | 'error'
  | 'warning'
  | 'focus'
  | 'load'
  | 'submit'

export function dispatchAnalyticEvent(
  event: string,
  category: AnalyticEventCategory,
  component: string,
  additionalProperties?: Record<string, any>,
) {
  try {
    const analyticsEvent = new CustomEvent('aaAnalyticEvent', {
      detail: {
        event,
        category,
        component: component,
        ...additionalProperties,
      },
      bubbles: true,
    })
    document.dispatchEvent(analyticsEvent)
  } catch (error) {
    console.warn('Error dispatching analytic event:', error)
  }
}
